import gql from 'graphql-tag';

export const GET_DEPARTMENTS = gql`
  query GetDepartments {
    bpf {
      result: departments {
        error
        success
        list {
          id
          name
        }
      }
    }
  }
`;
